<template>
    <footer>
        <h1>Ahmed El<span id="k">k</span>ashef</h1>
    </footer>
</template>

<style lang="scss" scoped>
@import "../assets/css/mixins";

footer {
    background: $blue;
    mix-blend-mode: unset;
    margin: 0;
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 1;

    h1 {
        padding: 0;
        margin: 0;
        font-family: 'Panchang';
        color: #fff;
        font-size: 8vw;
        letter-spacing: -5px;
        font-weight: lighter;
    }
}
</style>